var _defs, _g, _rect, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataVizFinalLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1500 928",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: url(#linear-gradient2);\n      }\n\n      .st1 {\n        fill: url(#linear-gradient1);\n      }\n\n      .st2 {\n        fill: #00879e;\n      }\n\n      .st3 {\n        clip-rule: evenodd;\n        fill: none;\n      }\n\n      .st4 {\n        fill: #102e50;\n      }\n\n      .st5 {\n        fill: url(#linear-gradient);\n      }\n\n      .st6 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M609.9,407.3h65.5c57.7,0,105-47.2,105-105s-47.2-105-105-105h0v-94.2c109.6,0,199.2,89.6,199.2,199.2s-89.6,199.2-199.2,199.2h-65.5v-94.2ZM496.9,228.7l34.2,34.2h78.9v144.5h-94.2v-129.2l-34.2-34.2h-53.1v-68.5h68.5v53.2ZM515.7,451.4h50.1v50.1h-50.1v-50.1ZM704.2,363.2h-50.1v-50.1h50.1v50.1ZM527.9,103.1h68.5v53.2l43,43h36.1v51.4h-51.4v-36.1l-43-43h-53.2v-68.5Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 545.5,
    y1: 516.3,
    x2: 772.3,
    y2: 58.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#102e50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00879e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient1",
    x1: 833.3,
    y1: 113.4,
    x2: 738.7,
    y2: 113.4,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient2",
    x1: 1118.1,
    y1: 294.8,
    x2: 859.5,
    y2: 294.8,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M86.1,567.4h82.5c35.7,0,80,5.4,109.6,43.3,20.2,24.1,29.2,54.8,29.2,89.8,0,77.9-42.2,133.7-135.9,133.7h-85.4v-266.7ZM128.6,796.6h45.1c62.7,0,91.6-40,91.6-95.5s-6.8-50.1-21.6-68.1c-14.1-16.2-35.3-28.1-69.6-28.1h-45.4v191.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M545.6,834.1h-37.5v-34.2c-13.7,26.3-41.8,40-72.8,40-63.1,0-100.6-49-100.6-103.8s43.6-103.8,100.6-103.8,63.8,21.6,72.8,40.4v-34.6h37.5v196.1ZM372.3,736.8c.4,29.2,20.9,68.1,68.5,68.1s51.2-16.6,60.9-38.9c4.3-9,6.5-19.1,6.8-29.2.4-10.1-1.4-20.2-5.8-29.2-9.4-22.7-31.4-40.4-62.7-40.4s-67.8,32.4-67.8,69.2v.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M609.1,667.2h-35.3v-29.2h35.3v-70.6h37.5v70.6h37.8v29.2h-37.8v166.9h-37.5v-166.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M902.5,834.1h-37.5v-34.2c-13.7,26.3-41.8,40-72.8,40-63.1,0-100.6-49-100.6-103.8s43.6-103.8,100.6-103.8,63.8,21.6,72.8,40.4v-34.6h37.5v196.1ZM729.1,736.8c.4,29.2,20.9,68.1,68.5,68.1s51.2-16.6,60.9-38.9c4.3-9,6.5-19.1,6.8-29.2.4-10.1-1.4-20.2-5.8-29.2-9.4-22.7-31.4-40.4-62.7-40.4s-67.8,32.4-67.8,69.2v.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M931.7,567.4h44l77.1,214.8,77.5-214.8h44l-100.6,266.7h-42.2l-99.8-266.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1203.1,638h37.5v196.1h-37.5v-196.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M1270.1,807.4l99.5-140.2h-96.6v-29.2h138v29.6l-96.2,137.3h99.1v29.2h-143.8v-26.7Z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 1203.1,
    y: 567.4,
    width: 37.5,
    height: 39.6
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st5",
    x: 428.4,
    y: 103.1,
    width: 446.2,
    height: 398.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M833.3,138.6l-18.1-50.5h-76.5c35.9,8.5,68.3,26.2,94.6,50.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1038.2,88.1l-111.7,309.8-26.9-74.8c-5,36-19.2,69.1-40.1,97l30.5,81.5h72.3l155.8-413.4h-80Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataVizFinalLogo);
export default __webpack_public_path__ + "static/media/DataViz Final Logo.610eff52f5e11e9d1540fced2df4b5da.svg";
export { ForwardRef as ReactComponent };